import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

export const TaskHeaderMoreButton = memo(
  ({
    style,
    color,
    onPress,
  }: {
    color?: string;
    onPress?: () => void;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        onPress={onPress}
        css={`
          align-items: center;
          justify-content: center;
          width: ${rpx(32)}px;
          height: ${rpx(32)}px;
        `}
        style={style}
      >
        <Icon name="more-vertical" size={rpx(24)} color={color ?? 'black'} />
      </TouchableOpacity>
    );
  },
);
